import React from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

/**
 * Shared search box: leading search icon, optional clear control.
 */
export default function SearchTextField({
  value,
  onChange,
  onClear,
  placeholder,
  'aria-label': ariaLabel,
  size = 'small',
  fullWidth = true,
  showClear = true,
  disabled,
  sx,
  ...rest
}) {
  const hasValue = Boolean(value && String(value).trim());
  const endAdornment =
    showClear && onClear && hasValue ? (
      <InputAdornment position="end">
        <IconButton size="small" aria-label="Clear search" onClick={onClear}>
          <ClearIcon fontSize="small" />
        </IconButton>
      </InputAdornment>
    ) : null;

  return (
    <TextField
      fullWidth={fullWidth}
      size={size}
      variant="outlined"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      sx={sx}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" color="action" />
          </InputAdornment>
        ),
        endAdornment,
      }}
      inputProps={{ 'aria-label': ariaLabel }}
      {...rest}
    />
  );
}
